/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import React from 'react';

interface Props {
  label: string;
  boolean?: boolean;
  data?: string | boolean | undefined;
  text?: string | undefined;
  blurred?: boolean;
  isOrange?: boolean;
}

const UserData: React.FC<Props> = function UserData({ label, boolean, data, text, blurred = false, isOrange =false }) {
  let value = data;

  if (boolean && typeof data === 'boolean' && text) {
    value = text;
  } else if (boolean && typeof data === 'boolean') {
    value = data ? 'Sì' : 'No';
  }

  if (typeof value === 'string') {
    value = value.trim();
  }

  return (
    <div>
      <p className={`pb-2 text-sm text-left font-primarybold ${isOrange ? 'text-primary pb-4 pt-2' : 'text-textgrey'} `}>{label}</p>
      <h2 className={`font-primarybold text-base text-black user-data-value ${blurred ? 'blur-sm' : ''}`}>{value}</h2>
    </div>
  );
};

UserData.defaultProps = { boolean: false, data: undefined, text: undefined, blurred: false };

export default UserData;